import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2dcea96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invest-tabel" }
const _hoisted_2 = { class: "invest-tabel-title" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("报名成功")
const _hoisted_4 = { style: {"color":"red"} }
const _hoisted_5 = { style: {"color":"red"} }
const _hoisted_6 = { style: {"color":"red"} }

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import Bottom from './components/bottom.vue'
import { MoreFilled } from '@element-plus/icons-vue'

import tool from "@/utils/tool";
import router from "@/router/index";
import { Plus } from '@element-plus/icons-vue';

type FormInstance = InstanceType<typeof ElForm>;

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const radio1 = ref('1')
const active = 3;
const activitiesStep = [
  {
    content: '报名',
    timestamp: '2018-04-12 20:46',
    size: 'large',
    type: 'primary',
    icon: MoreFilled,
  },
  {
    content: '缴费',
    timestamp: '2018-04-03 20:46',
    color: '#0bbd87',
    type: 'primary',
  },
  {
    content: '成功',
    timestamp: '2018-04-03 20:46',
    size: 'large',
  },
];

const isDisabled = ref(false);

var id = router.currentRoute.value.params.id;
if (typeof id == "string") {
  store.dispatch("frontTrainingModule/getActivityApply", { activityId: id }).then(
    (data) => {
      //成功
      if (data.result != null) {
        bindData.activityApply = data.result;
        if (bindData.activityApply.isPayed == 'Y') {
          bindData.activityApply.isPayedName = "是";
        }
        else {
          bindData.activityApply.isPayedName = "否";
        }
        if (bindData.activityApply.paymentWay == '1') {
          bindData.activityApply.payway = "微信";
        }
        else if (bindData.activityApply.paymentWay == '2') {
          bindData.activityApply.payway = "支付宝";
        }

        isDisabled.value = true;
        switch (bindData.activityApply.type) {
          case 1:
            bindData.title = "楼盘招商报名";
            break;
          case 2:
            bindData.title = "社区营销报名";
            break;
          case 3:
            bindData.title = "经销商招募报名";
            break;
          case 4:
            bindData.title = "拎包培训报名";
            break;
          case 5:
            bindData.title = "行业会议报名";
            break;
          case 6:
            bindData.title = "私享会报名";
            break;
          case 7:
            bindData.title = "拎包商加盟报名";
            break;
          default:
            bindData.title = "";
            break;
        }
      }
    },
    (error) => {
      console.log(error.msg);
    }
  );
}

const paymentFormRef = ref<FormInstance>();
const bindData = reactive({
  title: '',
  loginMember: {
    balance: 0,
  },
  paymentForm: {
  },
  memberName: '',
  activityApply: {
    id: '',
    code: '',
    type: 0,
    activityId: '',
    contact: '',
    mobile: '',
    cost: 0.00,
    couponFee: 0.00,
    couponNos: '',
    cashFee: 0.00,
    isPayed: '',
    isPayedName: '否',
    paymentWay: '',
    payway: '',
    outTradeNo: '',
  }
});

const ustore = useStore();

if (typeof id == "string") {
  bindData.activityApply.activityId = id;
}

bindData.memberName = ustore.state.loginMember == undefined ? '' : ustore.state.loginMember.companyName

const loadData = () => {
  store.dispatch("getMyInfo").then(
    (data) => {
      //成功
      bindData.memberName = data.result.companyName;
    },
    (error) => {
      ElMessageBox.alert(error.msg, "系统消息", {
        confirmButtonText: "关闭",
        callback: (action: Action) => { },
      });
    }
  );
};

if (ustore.state.loginMember == undefined) {
  loadData();
}


return (_ctx: any,_cache: any) => {
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_H3 = _resolveComponent("H3")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(bindData).title), 1),
      _createVNode(_component_el_steps, {
        active: active,
        "finish-status": "success"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(activitiesStep, (activityStep, index) => {
            return _createVNode(_component_el_step, {
              key: index,
              title: activityStep.content
            }, null, 8, ["title"])
          }), 64))
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_H3, { class: "invest-tabel-title" }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_el_form, {
                model: _unref(bindData).paymentForm,
                ref_key: "paymentFormRef",
                ref: paymentFormRef,
                "label-width": "120px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "姓名" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(_unref(bindData).activityApply.contact), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "电话" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(_unref(bindData).activityApply.mobile), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "报名费",
                    pop: "cost"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, "¥ " + _toDisplayString(_unref(bindData).activityApply.cost), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "是否已支付",
                    pop: "isPayed"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(_unref(bindData).activityApply.isPayedName), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "用券支付",
                    pop: "couponFee"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, "¥ " + _toDisplayString(_unref(bindData).activityApply.couponFee), 1)
                    ]),
                    _: 1
                  }),
                  (_unref(bindData).activityApply.couponNos!=null&&_unref(bindData).activityApply.couponNos.length>0)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "券号",
                        pop: "couponNos"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(_unref(bindData).activityApply.couponNos), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    label: "支付方式",
                    pop: "payway"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(_unref(bindData).activityApply.payway), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "现金支付",
                    pop: "cashFee"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, "¥ " + _toDisplayString(_unref(bindData).activityApply.cashFee), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "支付单号",
                    pop: "code"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(_unref(bindData).activityApply.code), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "流水号",
                    pop: "outTradeNo"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(_unref(bindData).activityApply.outTradeNo), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, { class: "invest-tabel-btn" })
    ]),
    _createVNode(Bottom)
  ]))
}
}

})